<template>
  <div class="row-container">
    <TextField
      v-model="item.quantity"
      type="number"
      :min="1"
      name="quantity"
      no-label
      class="number-input mr-3"
    />
    <div class="flex-1 mb-1 label unit-name">{{ item.unit_name }}</div>
    <div class="mr-3 label">Every</div>
    <PeriodSelector :id="item.item_id" :frequency="item.frequency" full-list />
    <i
      class="fas fa-trash-alt thumbnail-trash ml-3 link"
      @click="$emit('delete-item', item.item_id)"
    ></i>
  </div>
</template>

<script>
import TextField from "@/components/TextField.vue";
import useVuelidate from "@vuelidate/core";
import PeriodSelector from "./PeriodSelector.vue";

export default {
  components: {
    TextField,
    PeriodSelector
  },
  props: {
    item: {
      type: Object,
      default: () => ({ frequency: {} })
    }
  },
  emits: ["delete-item"],
  setup() {
    return {
      v$: useVuelidate()
    };
  }
};
</script>

<style>
.row-container {
  display: flex;
  flex-grow: 1;
  color: var(--darkblue);
  align-items: baseline;
}

.thumbnail-trash {
  font-size: 18px;
  margin-top: 0.5rem;
}

.number-input {
  width: 60px;
  min-width: 60px;
}

.unit-name {
  font-size: 0.9rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-top: 0.3rem;
}
</style>
